module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会员id",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.offline_card_id),
      callback: function($$v) {
        _vm.offline_card_id = $$v
      },
      expression: "offline_card_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "来源",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.source_from),
      callback: function($$v) {
        _vm.source_from = $$v
      },
      expression: "source_from"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "有无购买记录",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "change": _vm.ifHaveOrderRecords
    },
    model: {
      value: (_vm.order_records),
      callback: function($$v) {
        _vm.order_records = $$v
      },
      expression: "order_records"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "有记录",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无记录",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 2,
      "lg": 4
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('search')
      }
    }
  }, [(_vm.panel.search) ? _c('span', [_vm._v("点击收缩更多操作")]) : _c('span', [_vm._v("点击展开更多操作")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont",
    class: _vm.panel.search ? 'el-icon-arrow-down' : 'el-icon-arrow-right'
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.search),
      expression: "panel.search"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 4,
      "lg": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择标签",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "change": _vm.tagSearchUserChange
    },
    model: {
      value: (_vm.params.tag_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "tag_id", $$v)
      },
      expression: "params.tag_id"
    }
  }, _vm._l((_vm.tag.list), function(item) {
    return _c('el-option', {
      key: item.tag_id,
      attrs: {
        "label": item.tag_name,
        "value": item.tag_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 4,
      "lg": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "是否付费会员",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "change": _vm.isvip99Flag
    },
    model: {
      value: (_vm.params.vip99_flag),
      callback: function($$v) {
        _vm.$set(_vm.params, "vip99_flag", $$v)
      },
      expression: "params.vip99_flag"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "付费会员",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "全部会员",
      "value": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "推荐人手机号",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.inviter_mobile),
      callback: function($$v) {
        _vm.inviter_mobile = $$v
      },
      expression: "inviter_mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 9,
      "lg": 9
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.created),
      callback: function($$v) {
        _vm.created = $$v
      },
      expression: "created"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.search),
      expression: "panel.search"
    }],
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.remarks),
      callback: function($$v) {
        _vm.$set(_vm.params, "remarks", $$v)
      },
      expression: "params.remarks"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.remarksSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "姓名",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.username),
      callback: function($$v) {
        _vm.$set(_vm.params, "username", $$v)
      },
      expression: "params.username"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.remarksSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.search),
      expression: "panel.search"
    }],
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 12
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 2,
      "placeholder": "手机号群发，多个手机号使用回车换行",
      "type": "textarea",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.mobiles),
      callback: function($$v) {
        _vm.mobiles = $$v
      },
      expression: "mobiles"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 12
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.Serachmobiles
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addMemberTag
    }
  }, [_vm._v("打标签")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addResource
    }
  }, [_vm._v("赠送优惠券")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.smsSends
    }
  }, [_vm._v("群发短信")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.delUserWxappInfo()
      }
    }
  }, [_vm._v("用户撤销授权")]), _vm._v(" "), (_vm.is_distributor) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.setSalesman(false)
      }
    }
  }, [_vm._v("设置导购员")]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportLogData
    }
  }, [_vm._v("预存款记录导出")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "日志导出",
      "visible": _vm.exportdialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.exportdialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.logform
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.logform.times),
      callback: function($$v) {
        _vm.$set(_vm.logform, "times", $$v)
      },
      expression: "logform.times"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.exportLog()
      }
    }
  }, [_vm._v("确认导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.exportdialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportdialogFormVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量删除用户授权",
      "visible": _vm.batchDelDialog,
      "before-close": _vm.handleCancelBatchDelDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDelDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "210px"
    }
  }, [_c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "用户 open_id"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 16,
      "lg": 16
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "placeholder": "多个 openID 使用回车符换行",
      "type": "textarea",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.openIDs),
      callback: function($$v) {
        _vm.openIDs = $$v
      },
      expression: "openIDs"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDelDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchDelUserWxappInfo
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "会员下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    attrs: {
      "data": _vm.memberData,
      "row-key": _vm.getRowKeys,
      "height": _vm.wheight - 210,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "align": "center",
      "label": "全选"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "user_card_code",
      "label": "会员卡编号",
      "width": "130"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ID",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.user_id) + "\n        ")]
      }
    }], null, false, 85351486)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "width": "136"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.mobile) + "\n          "), _c('i', {
          staticClass: "iconfont icon-pencil-alt mobile-editor",
          on: {
            "click": function($event) {
              return _vm.editMobile(scope.row)
            }
          }
        })]
      }
    }], null, false, 1706264041)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.username) + "\n          "), _c('i', {
          staticClass: "iconfont icon-pencil-alt mobile-editor",
          on: {
            "click": function($event) {
              return _vm.editUsername(scope.row)
            }
          }
        })]
      }
    }], null, false, 2203636777)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sex == '2') ? _c('span', [_vm._v("女")]) : (scope.row.sex == '1') ? _c('span', [_vm._v("男")]) : _c('span', [_vm._v("未知")])]
      }
    }], null, false, 2678050211)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "flag",
      "label": "是否实名",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.flag == '0') ? _c('el-tag', {
          attrs: {
            "type": "error"
          }
        }, [_vm._v("未实名")]) : (scope.row.flag == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已实名")]) : _c('el-tag', [_vm._v("未实名")])]
      }
    }], null, false, 3723041802)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realname",
      "label": "真实姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offline_card_id",
      "label": "中台会员id",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inviter",
      "label": "推荐人",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "注册日期",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("注册时间"), _c('br'), _vm._v(_vm._s(_vm._f("datetime")(scope.row.created, 'yyyy-MM-dd hh:mm:ss')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created)))])])]
      }
    }], null, false, 644858458)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source_from",
      "label": "来源",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "disabled",
      "label": "是否禁用",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "0",
            "active-color": "#ff4949",
            "inactive-color": "#13ce66"
          },
          on: {
            "change": function($event) {
              return _vm.acitonDisabled(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.disabled),
            callback: function($$v) {
              _vm.$set(scope.row, "disabled", $$v)
            },
            expression: "scope.row.disabled"
          }
        }, [_vm._v("</>\n          ")])]
      }
    }], null, false, 2383430112)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.remarks) + "\n          "), _c('i', {
          staticClass: "iconfont icon-pencil-alt mobile-editor",
          on: {
            "click": function($event) {
              return _vm.isEdit(scope.row)
            }
          }
        })]
      }
    }], null, false, 3090104706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tagList",
      "label": "标签",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.vip99) ? _c('el-tag', {
          style: ('color:#ffffff'),
          attrs: {
            "color": "#d81e06"
          }
        }, [_vm._v("付费会员")]) : _vm._e(), _vm._v(" "), _vm._l((scope.row.tagList), function(taglist) {
          return _c('el-tag', {
            key: taglist.index,
            staticStyle: {
              "display": "inline-block",
              "margin-right": "3px"
            },
            style: ('color:' + taglist.font_color),
            attrs: {
              "color": taglist.tag_color,
              "size": "mini"
            }
          }, [_vm._v(_vm._s(taglist.tag_name))])
        })]
      }
    }], null, false, 2467910899)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "380"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getDetail(scope.row.user_id)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.tagUpdate(scope.row)
            }
          }
        }, [_vm._v("标签")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateOfflineCode(scope.row)
            }
          }
        }, [_vm._v("更新线下卡")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editPassword(scope.row)
            }
          }
        }, [_vm._v("重置登录密码")])]
      }
    }], null, false, 3835657318)
  })], 1), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.allCheckEvent
    },
    model: {
      value: (_vm.allCheck),
      callback: function($$v) {
        _vm.allCheck = $$v
      },
      expression: "allCheck"
    }
  }, [_vm._v("全选所有")]), _vm._v(" "), _c('span', [_vm._v("(注：只支持群发优惠券和群发短息)")]), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "赠送优惠券",
      "visible": _vm.addCouponsDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.addCouponsDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "搜索优惠券"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "搜索优惠券"
      },
      model: {
        value: (_vm.couponsParams.title),
        callback: function($$v) {
          _vm.$set(_vm.couponsParams, "title", $$v)
        },
        expression: "couponsParams.title"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "el-icon-search"
      },
      on: {
        "click": _vm.searchCoupons
      },
      slot: "append"
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "选择优惠券"
      }
    }, [_c('el-transfer', {
      attrs: {
        "titles": ['优惠券列表', '已选中'],
        "data": _vm.couponsList
      },
      model: {
        value: (_vm.addCouponsItems),
        callback: function($$v) {
          _vm.addCouponsItems = $$v
        },
        expression: "addCouponsItems"
      }
    }, [_c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "left-footer"
      },
      slot: "left-footer"
    }, [(_vm.coupons_total_count > _vm.couponsParams.page_size) ? _c('el-pagination', {
      attrs: {
        "small": "",
        "layout": "prev, pager, next",
        "total": _vm.coupons_total_count,
        "page-size": _vm.couponsParams.page_size
      },
      on: {
        "current-change": _vm.handleCouponsChange
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "right-footer"
      },
      slot: "right-footer"
    })])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [_vm._v("确定添加")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量修改付费会员延期",
      "visible": _vm.vipGradeDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.vipGradeDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "付费会员类型"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.vipGradeDelay.vip_grade_id),
      callback: function($$v) {
        _vm.$set(_vm.vipGradeDelay, "vip_grade_id", $$v)
      },
      expression: "vipGradeDelay.vip_grade_id"
    }
  }, _vm._l((_vm.vipGrade), function(item) {
    return _c('el-option', {
      key: item.lv_type,
      attrs: {
        "label": item.grade_name,
        "value": item.vip_grade_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "延期条件"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.vipGradeDelay.filter),
      callback: function($$v) {
        _vm.$set(_vm.vipGradeDelay, "filter", $$v)
      },
      expression: "vipGradeDelay.filter"
    }
  }, [_c('el-option', {
    key: "users",
    attrs: {
      "label": "已选择会员",
      "value": "users"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "expired",
    attrs: {
      "label": "付费会员已失效",
      "value": "expired"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.vipGradeDelay.filter == 'users') ? _c('el-form-item', {
    staticClass: "content-left"
  }, [(_vm.smsForm.mobile.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "",
      "type": "success",
      "closable": false
    }
  }, _vm._l((_vm.smsForm.mobile), function(item) {
    return _c('span', [_vm._v(" " + _vm._s(item) + "、")])
  }), 0), _vm._v(" "), _c('span', [_vm._v("共：" + _vm._s(_vm.smsForm.mobile.length))])], 1) : _c('span', [_vm._v("请先选择会员")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "延期天数"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vipGradeDelay.add_day),
      callback: function($$v) {
        _vm.$set(_vm.vipGradeDelay, "add_day", $$v)
      },
      expression: "vipGradeDelay.add_day"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleVipGradeDelay(true)
      }
    }
  }, [_vm._v("确定延期")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量设置导购员",
      "visible": _vm.setSalesmanDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.setSalesmanDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "选择导购员"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.salesman_id),
      callback: function($$v) {
        _vm.salesman_id = $$v
      },
      expression: "salesman_id"
    }
  }, _vm._l((_vm.salesman), function(item) {
    return _c('el-option', {
      key: item.salesman_id,
      attrs: {
        "label": item.salesman_name,
        "value": item.salesman_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setSalesman(true)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑会员等级",
      "visible": _vm.updateGradeDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.updateGradeDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "会员等级"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.gradeForm.grade_id),
      callback: function($$v) {
        _vm.$set(_vm.gradeForm, "grade_id", $$v)
      },
      expression: "gradeForm.grade_id"
    }
  }, _vm._l((_vm.levelData), function(item) {
    return _c('el-option', {
      key: item.grade_id,
      attrs: {
        "label": item.grade_name,
        "value": item.grade_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "备注"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "focus": "",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.gradeForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.gradeForm, "remarks", $$v)
      },
      expression: "gradeForm.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.gradeUpdateSubmit
    }
  }, [_vm._v("确定修改")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新线下会员卡【确认会员卡信息有误或者没有同步到np再做更新】",
      "visible": _vm.updateOfflineCodeDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.updateOfflineCodeDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.gradeForm.username),
      callback: function($$v) {
        _vm.$set(_vm.gradeForm, "username", $$v)
      },
      expression: "gradeForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.gradeForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.gradeForm, "mobile", $$v)
      },
      expression: "gradeForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "线下会员卡ID"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.gradeForm.offline_card_id),
      callback: function($$v) {
        _vm.$set(_vm.gradeForm, "offline_card_id", $$v)
      },
      expression: "gradeForm.offline_card_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center",
    attrs: {
      "label": "线下会员卡号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.gradeForm.offline_card_code),
      callback: function($$v) {
        _vm.$set(_vm.gradeForm, "offline_card_code", $$v)
      },
      expression: "gradeForm.offline_card_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushMemberCenter
    }
  }, [_vm._v("推送会员中台")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "群发短信",
      "visible": _vm.smsSeedsDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.smsSeedsDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      staticClass: "content-left"
    }, [(_vm.overall == 0) ? _c('span', [_c('el-alert', {
      attrs: {
        "title": "",
        "type": "success",
        "closable": false
      }
    }, _vm._l((_vm.smsForm.mobile), function(item) {
      return _c('span', [_vm._v(" " + _vm._s(item) + "、")])
    }), 0), _vm._v(" "), _c('span', [_vm._v("共：" + _vm._s(_vm.smsForm.mobile.length))])], 1) : _c('span', [_c('el-alert', {
      attrs: {
        "title": "",
        "type": "success",
        "closable": false
      }
    }, [_c('span', [_vm._v("您已选择全部用户")])]), _vm._v(" "), _c('span', [_vm._v("共：" + _vm._s(_vm.total_count))])], 1)]), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-input', {
      attrs: {
        "focus": "",
        "type": "textarea",
        "rows": 4,
        "placeholder": "请输入短信内容"
      },
      on: {
        "blur": _vm.checkNum
      },
      model: {
        value: (_vm.smsForm.sms_content),
        callback: function($$v) {
          _vm.$set(_vm.smsForm, "sms_content", $$v)
        },
        expression: "smsForm.sms_content"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.smsForm.sms_content.length))])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.onSmsSends
      }
    }, [_vm._v("确定发送")])], 1)], 1), _vm._v(" "), [_c('el-alert', {
      attrs: {
        "title": "短信基础",
        "type": "info",
        "description": "1、短信字符<=67个字符，按照70个字符一条短信计算；短信内容中，汉字、字母、符号、数字、空格全按一个字符算，不分半角、全角。含有标签（如短信签名、商品名、链接）的短信以实际发送时字符数计算；超过规定的67个字符的短信内容将会被拆分为两条或多条短信\n                          2、短信内容禁止有‘测试，test，错乱字符’等，这类短信会被拦截不予发送。\n                          3、短信接收不到原因：手机号黑名单发送不了；内容不正规不允发送；时间段导致延迟；被手机拦截软件拦截；该手机号短信接收上限；该手机号状态不正常（欠费，停机，空号，信号不正常）详询客服\n                          4、 短信内容切记出现敏感类字眼，如出现有的话，系统是发送不出去被拦截掉的哦。\n                          5、 短信内容当中不允许出现两个【】或 ⎣⎤ 括弧"
      }
    }), _vm._v(" "), _c('el-alert', {
      attrs: {
        "title": "营销短信（手动输入的短信）",
        "type": "info",
        "description": "营销短信发送时间为8：00~21:00，双十一双十二大促期间，短信发送时间可24小时。"
      }
    }), _vm._v(" "), _c('el-alert', {
      attrs: {
        "title": "短信限制注意事项",
        "type": "info",
        "description": "1、通知短信加营销短信同一号码月限制50条。2、相同内容，相同手机号，日限制2条，第3条会被拦截。"
      }
    })]]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "为会员打标签",
      "visible": _vm.tag.dialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.tag, "dialog", $event)
      }
    }
  }, [_c('div', {
    staticClass: "tag-users view-flex view-flex-middle"
  }, [_c('i', {
    staticClass: "iconfont icon-user-circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, _vm._l((_vm.tag.editUser), function(item) {
    return _c('span', [_vm._v(" " + _vm._s(item) + "，")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "selected-tags view-flex"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("已选中标签：")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, _vm._l((_vm.tag.currentTags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": "",
        "size": "small",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.tagRemove(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])
  }), 1)]), _vm._v(" "), _c('div', _vm._l((_vm.tag.tags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "tag-item",
      attrs: {
        "size": "medium",
        "color": "#ffffff",
        "disable-transitions": false
      },
      nativeOn: {
        "click": function($event) {
          return _vm.tagAdd(tag, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag.tag_name) + "\n        ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.tag.dialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitMemberTag
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "修改会员手机号",
      "visible": _vm.editMobileDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editMobileDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "会员名称"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.form.username) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "原手机号"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.form.oldMobile) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "新手机号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "手机号"
      },
      model: {
        value: (_vm.form.newMobile),
        callback: function($$v) {
          _vm.$set(_vm.form, "newMobile", $$v)
        },
        expression: "form.newMobile"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.onEditMobileSubmit
      }
    }, [_vm._v("确定添加")])], 1)], 1)], _vm._v(" "), [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "data": _vm.operateLog,
        "height": "580",
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "old_data",
        "label": "原手机号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "new_data",
        "label": "修改后手机号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "operater",
        "label": "操作员"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "created",
        "label": "操作时间"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "修改会员备注",
      "visible": _vm.isEditRemarks,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isEditRemarks = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "备注"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "输入备注"
      },
      model: {
        value: (_vm.remarksForm.remarks),
        callback: function($$v) {
          _vm.$set(_vm.remarksForm, "remarks", $$v)
        },
        expression: "remarksForm.remarks"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editRemarks()
        }
      }
    }, [_vm._v("确定")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "修改会员姓名",
      "visible": _vm.editUsernameDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editUsernameDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "会员id"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.updateUserForm.user_id) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "手机号"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.updateUserForm.mobile) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "会员名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "会员名称"
      },
      model: {
        value: (_vm.updateUserForm.username),
        callback: function($$v) {
          _vm.$set(_vm.updateUserForm, "username", $$v)
        },
        expression: "updateUserForm.username"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editUsernameSubmit()
        }
      }
    }, [_vm._v("确定")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "重置会员密码",
      "visible": _vm.editPasswordDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editPasswordDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "手机号"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.editpassForm.mobile) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "密码"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "密码"
      },
      model: {
        value: (_vm.editpassForm.password),
        callback: function($$v) {
          _vm.$set(_vm.editpassForm, "password", $$v)
        },
        expression: "editpassForm.password"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editPassSubmit()
        }
      }
    }, [_vm._v("确定")])], 1)], 1)]
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-551f4946", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-551f4946"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/members/list.vue
// module id = 2724
// module chunks = 0